import $ from 'jquery'

const DEFAULTS = {
  stickyClass: 'sticky',
  offset: 0
}

class Unstick {
  constructor (element) {
    this.$element = element
    this.$reference = $(this.$element.attr('data-unstick-element'))
    this.$window = $(window)

    this.options = {}
  }

  /**
   * Runs @method bindListeners
   * set stickyClass and offset value
   *
   * @method init
   * @return {object} The instance
   */
  init () {
    this.options.stickyClass = this.$element.attr('data-unstick-class') || DEFAULTS.stickyClass
    this.options.offset = +this.$element.attr('data-unstick-offset') || DEFAULTS.offset
    this.$element.addClass('sticky')

    this.bindListeners()
    this.onWindowScroll()

    return this
  }

  /**
   * Attach @method onWindowScroll when scroll event is fired
   *
   * @method bindListeners
   */
  bindListeners () {
    this.$window.on('scroll', this.onWindowScroll.bind(this))
  }

  /**
   * toggle $element class based on @method isReferenceVisible return
   *
   * @method onWindowScroll
   */
  onWindowScroll () {
    this.$element.toggleClass(this.options.stickyClass, !this.isReferenceVisible())
  }

  /**
   * Check if $window scrollTop is greater than $reference offset top
   *
   * @method isReferenceVisible
   * @return Boolean
   */
  isReferenceVisible () {
    return this._getWindowOffset() > this._getReferOffsetTop()
  }

  /**
   * Get $reference offset.top position
   *
   * @method _getReferOffsetTop
   * @return int
   */
  _getReferOffsetTop () {
    return this.$reference.offset().top
  }

  /**
   * Get $window scrollTop position
   *
   * @method _getWindowOffset
   * @return int
   */
  _getWindowOffset () {
    return this.$window.scrollTop() + this.$window.height() + this.options.offset
  }
}

export default ($el) => new Unstick($el).init()

export { Unstick as Component }
